import { cn } from "@/core/helpers/cn";

type Props = {
  percent: number;
  className?: string;
};

function ProgressRadial({ percent, className }: Props) {
  return (
    <div
      className={cn(
        "aspect-square rounded-full w-16 bg-canvas text-white flex items-center justify-center font-bold text-xl",
        className,
      )}
      style={{ "--progress": `${percent}%` } as React.CSSProperties}
    >
      <div className="absolute inset-1.75 rounded-full bg-gradient-accent opacity-10 hidden   dark:block" />
      <div className="absolute inset-1.75 rounded-full bg-gradient-accent opacity-40 [mask-image:radial-gradient(circle_at_center,transparent,transparent_calc(100%-.875rem-0.5px),black_calc(100%-.875rem))]" />
      <div className="absolute inset-[0.34375rem] rounded-full [mask-image:conic-gradient(black,black_var(--progress),transparent_var(--progress))]">
        <div className="absolute inset-0 rounded-full bg-gradient-accent [mask-image:radial-gradient(circle_at_center,transparent,transparent_calc(100%-1.125rem-0.5px),black_calc(100%-1.125rem))]" />
      </div>
      <div>{percent}</div>
    </div>
  );
}

export default ProgressRadial;
